import actions from './actions'

const initState = {
  OCRData: {},
  imageQualityCheckData: {},
  imageQualityCheckLoading: false,
  imageQualityCheckError: null,
  loading: false,
  error: null
}

export default function OCR (state = initState, action) {
  switch (action.type) {
    case actions.CLEAR_OCR_REDUX:
      return { ...initState }

    case actions.CLEAR_OCR_ERROR_MESSAGE:
      return {
        ...state,
        imageQualityCheckError: null,
        error: null
      }

    case actions.CLEAR_OCR_DATA:
      return {
        ...state,
        OCRData: {},
        imageQualityCheckData: {}
      }

    case actions.SEND_KTP_OCR_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }

    case actions.SEND_KTP_OCR_SUCCESS:
      return {
        ...state,
        loading: false,
        OCRData: action.payload
      }

    case actions.SEND_KTP_OCR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case actions.SEND_IMAGE_QUALITY_CHECK_REQUEST:
      return {
        ...state,
        imageQualityCheckLoading: true,
        imageQualityCheckError: null
      }

    case actions.SEND_IMAGE_QUALITY_CHECK_SUCCESS:
      return {
        ...state,
        imageQualityCheckLoading: false,
        imageQualityCheckData: action.payload
      }

    case actions.SEND_IMAGE_QUALITY_CHECK_FAILURE:
      return {
        ...state,
        imageQualityCheckLoading: false,
        imageQualityCheckError: action.payload
      }

    default:
      return state
  }
}
